<template>
    <div id="CreateBlog" class="text-center">
        <b-form-input class="mb-3" v-model="title" placeholder="输入标题"></b-form-input>
        <b-form-input class="mb-3" v-model="description" placeholder="输入简介"></b-form-input>
        <b-form-tags class="mb-3" input-id="tags-basic" v-model="categoryNames"></b-form-tags>
        <b-form-select class="mb-3" v-model="blogType" :options="blogTypeOptions"></b-form-select>
        <mavon-editor style="min-height:800px"
            ref=md
            v-model="context" 
            v-bind:toolbars="markdownOption"
            v-on:save="save"
            v-on:imgAdd="imgAdd"/>
        <!-- <b-button class="mt-3" variant="outline-primary" v-on:click="clickSave">保存</b-button> -->
    </div>
</template>



<script>

import Vue from 'vue'
import mavonEditor from 'mavon-editor'
import axios from 'axios'
// import GlobalConstant from '../constants/GlobalConstant'
import 'mavon-editor/dist/css/index.css'

Vue.use(mavonEditor)

axios.defaults.withCredentials=true;

export default {
     "name": "EditBlog",

    data() {
        return { 
            markdownOption: {
                bold: true, // 粗体
                italic: true, // 斜体
                header: true, // 标题
                underline: true, // 下划线
                strikethrough: true, // 中划线
                mark: true, // 标记
                superscript: true, // 上角标
                subscript: true, // 下角标
                quote: true, // 引用
                ol: true, // 有序列表
                ul: true, // 无序列表
                link: true, // 链接
                imagelink: true, // 图片链接
                code: true, // code
                table: true, // 表格
                fullscreen: true, // 全屏编辑
                readmodel: true, // 沉浸式阅读
                htmlcode: true, // 展示html源码
                help: true, // 帮助
                /* 1.3.5 */
                undo: true, // 上一步
                redo: true, // 下一步
                trash: true, // 清空
                save: true, // 保存（触发events中的save事件）
                /* 1.4.2 */
                navigation: true, // 导航目录
                /* 2.1.8 */
                alignleft: true, // 左对齐
                aligncenter: true, // 居中
                alignright: true, // 右对齐
                /* 2.2.1 */
                subfield: true, // 单双栏模式
                preview: true, // 预览
            },
            id : 0,
            card : "",
            title: '',
            description : '',
            context: '' ,
            categoryNames : [],
            blogType:1,
            blogTypeOptions: [
                { value: 1, text: '文字博客' },
                { value: 2, text: '视频博客'}
            ]
        }
    },

    beforeMount: function(){
        const ss = window.sessionStorage
        var token = ss.getItem('token')
        // var _this = this;
        if(!token){
            //console.log(token);
            window.location.href = '/admin/login';
        }else{
            axios.post('/api/admin/check', {'token':token})
                .then(function(response){
                    console.log(response);
                    var res = response.data;
                    if(res.code == 0){
                        window.location.href = '/admin/login';
                    }
                })
                .catch(function(error){
                    console.log(error);
                })
        }   
    },

    mounted: function(){
        console.log("mounted!!!!");
        var _this = this;
        _this.id = _this.$route.query.id ? _this.$route.query.id : 0;
        _this.card = _this.$route.query.card ? _this.$route.query.card : "";
        _this.init();   
    },
    methods: {
        init : function(){
            console.log("card = " + this.card);
            if(this.card){
                var _this = this;
                axios.get('/api/blog/' + this.card)
                    .then(function(response){
                        console.log(response);
                        var res = response.data;
                        if(res.code == 1){
                            console.log(res.data);
                            _this.$set(_this, "context", res.data.mdContext);
                            _this.$set(_this, "title", res.data.title);
                            _this.$set(_this, "description", res.data.description);
                            _this.$set(_this, "blogType", res.data.type);
                            _this.$set(_this, "categoryNames", res.data.categoryNames);
                        }
                    })
                    .catch(function(error){
                        console.log(error);
                    })
            }

        },
        save : function(value, render){
            console.log(value);
            console.log(render);
            const ss = window.sessionStorage
            var token = ss.getItem('token')
            var _this = this;
            var params = {};
            params.id = this.id;
            params.card = this.card;
            params.title = this.title;
            params.description = this.description;
            params.mdContext = value;
            params.renderContext = render;
            params.categoryNames = this.categoryNames;
            params.type = this.blogType;
            axios({
                url: '/api/admin/blog/save',
                method: 'post',
                data: params,
                headers: { 
                    //'Content-Type': 'multipart/form-data'
                    'token': token
                },
            }).then(function(response){
                    console.log(response);
                    _this.$bvToast.toast('保存成功！', {
                        title: `成功`,
                        toaster: 'b-toaster-top-right',
                        variant: 'success',
                        solid: true,
                        appendToast: false
                    });
                    //1s后跳转到这条博文的编辑页面
                    setTimeout(function(){
                        window.location.href = '/admin/editBlog?card=' + response.data.data;
                    }, 1000);
                }).catch(function(error){
                    console.log(error)
                })
        },
        imgAdd : function(pos, $file){
            console.log("pos" + pos);
            console.log("file" + $file);
            const ss = window.sessionStorage
            var token = ss.getItem('token')
            var formdata = new FormData();
            var _this = this;
            formdata.append('pic', $file);
            axios({
                url: '/api/admin/pic/save',
                method: 'post',
                data: formdata,
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    'token': token
                },
            }).then((response) => {
                console.log(response);
                var res = response.data;
                if(res.code == 1){
                    // 第二步.将返回的url替换到文本原位置![...](0) -> ![...](url)
                    // $vm.$img2Url 详情见本页末尾
                    //$vm.$img2Url(pos, url);
                    var url = res.data;
                    this.$refs.md.$img2Url(pos, url);
                    
                }else{
                    _this.$bvToast.toast('上传图片错误！', {
                        title: `错误`,
                        toaster: 'b-toaster-top-right',
                        variant: 'danger',
                        solid: true,
                        appendToast: false
                    })
                }
           }).catch(function(error){
               _this.$bvToast.toast('上传图片错误！' + error, {
                    title: `错误`,
                    toaster: 'b-toaster-top-right',
                    variant: 'danger',
                    solid: true,
                    appendToast: false
                })
           });    


        }
        // clickSave : function(){
        //     // console.log(this.$refs.md.value);
        //     // console.log(this.$refs.md.htmlcode);
        //     // var params = {};
        //     // params.id = this.id;
        //     // params.title = this.title;
        //     // params.description = this.description;
        //     // params.mdContext = value;
        //     // params.renderContext = render;
        //     // params.categoryNames = this.categoryNames;
        //     // axios.post('http://127.0.0.1:8080/api/admin/blog/save', params)
        //     //     .then(function(response){
        //     //         console.log(response)
        //     //     }).catch(function(error){
        //     //         console.log(error)
        //     //     })
        // }
    }
    
}


</script>

<style scoped>
    
</style>